import { createAPIActions } from 'barnyard/utils';
import { APP_URL } from '../constants';

// Various URLs we care about
export const NAME = 'signup';
export const BASE_URL = `/${APP_URL}/${NAME}`;
export const USER_FORM_URL = `${BASE_URL}/user`;
export const CLINIC_FORM_URL = `${BASE_URL}/clinic`;
export const VENDOR_FORM_URL = `${BASE_URL}/vendors`;
export const FINISHED_URL = '/react/integration';

// Different form identifies
export const SIGNUP_FORM = 'UserInformation';
export const BUYER_UPDATE_FORM = 'BuyerUpdateForm';
export const VENDOR_UPDATE_FORM = 'VendorUpdateForm';

// Buyer Actions
export const BUYER_FETCH_FORM_FIELDS = createAPIActions('BUYER_FETCH_FORM_FIELDS');
export const BUYER_UPDATE = createAPIActions('BUYER_UPDATE');

// Profile Actions
export const PROFILE_CREATE = createAPIActions('PROFILE_CREATE');
export const PROFILE_FETCH = createAPIActions('PROFILE_FETCH');

export const ReasonDetails = {
  PEOPLE_REP: 'Who at which company?',
  PEOPLE_COWORKER: 'How did they hear?',
  PEOPLE_CLINIC: 'Which clinic?',
  PEOPLE_CONSULTANT: 'Who specifically?',
  INTERNET_FACEBOOK: 'Which group?',
  INTERNET_SOCIAL_MEDIA: 'Which platform + who specifically?',
  INTERNET_VIN_MESSAGE_BOARD: 'What was the topic?',
  INTERNET_SEARCH: 'What were you searching for?',
  INTERNET_ADVERTISEMENT: 'Where did you see it?',
  INDUSTRY_CORPORATE: 'Who specifically?',
  INDUSTRY_BUYING: 'Which group and who specifically?',
  INDUSTRY_AVMA: 'How specifically?',
  INDUSTRY_DECHRA: 'How specifically?',
  INDUSTRY_ORGANIZATIONS: 'Who and which organization?',
  OTHER_CONFERENCE: ' How, and at which conference?',
  OTHER_PUBLICATION: 'Which article or publication?',
  OTHER_OTHER: 'How did you hear?',
  VETCOVE_PAPER_MAIL: 'What was the mailer?',
  VETCOVE_MARKETING_EMAIL: 'What email specifically?',
  VETCOVE_CALL: 'Who called you?',
  VETCOVE_REP_EMAIL: 'Who emailed you?'
};

export const People = {
  name: 'People',
  key_values: {
    PEOPLE_CLINIC: 'Another Clinic',
    PEOPLE_CONSULTANT: 'Consultant/Service Provider',
    PEOPLE_REP: 'Industry Rep',
    PEOPLE_COWORKER: 'Someone at my Practice'
  }
};

export const Internet = {
  name: 'Internet',
  key_values: {
    INTERNET_FACEBOOK: 'Facebook Group',
    INTERNET_SEARCH: 'Google/Search Engine',
    INTERNET_ADVERTISEMENT: 'Online Advertisement',
    INTERNET_SOCIAL_MEDIA: 'Other Social Media',
    INTERNET_VIN_MESSAGE_BOARD: 'Vin or Message Board',
  }
};

export const Industry = {
  name: 'Industry',
  key_values: {
    INDUSTRY_AVMA: 'AVMA',
    INDUSTRY_DECHRA: 'Dechra Rewards',
    INDUSTRY_BUYING: 'Buying Group/GPO',
    INDUSTRY_CORPORATE: 'Corporate Group',
    INDUSTRY_ORGANIZATIONS: 'Industry Organizations',
  }
};

export const Other = {
  name: 'Other',
  key_values: {
    OTHER_PUBLICATION: 'Article/Publication',
    OTHER_CONFERENCE: 'Conference',
    OTHER_OTHER: 'Other',
  }
};

export const Vetcove = {
  name: 'Vetcove',
  key_values: {
    VETCOVE_CALL: 'Vetcove Called Me',
    VETCOVE_MARKETING_EMAIL: 'Vetcove Marketing Email',
    VETCOVE_PAPER_MAIL: 'Vetcove Paper Mail',
    VETCOVE_REP_EMAIL: 'Vetcove Rep Emailed Me',
  }
};

export const ReasonCategories = { groups: [People, Internet, Industry, Vetcove, Other] };

export const Pims = [
  { name: '123Pet', key: '123pet' },
  { name: 'Advantage', key: 'advantage' },
  { name: 'AltaPoint', key: 'altapoint' },
  { name: 'Avimark', key: 'avimark' },
  { name: 'Clientrax', key: 'clientrax' },
  { name: 'Complete Clinic', key: 'complete_clinic' },
  { name: 'Cornerstone', key: 'cornerstone' },
  { name: 'DaySmart', key: 'daysmart' },
  { name: 'Digitail', key: 'digitail' },
  { name: 'DVM Manager', key: 'dvm_manager' },
  { name: 'DVMax', key: 'dvmax' },
  { name: 'eVetPractice', key: 'evet_practice' },
  { name: 'EzyVet', key: 'ezyvet' },
  { name: 'Hippo', key: 'hippo' },
  { name: 'HVMS Server', key: 'hvms_server' },
  { name: 'Idexx Neo', key: 'idexx_neo' },
  { name: 'Impromed', key: 'impromed' },
  { name: 'Instinct', key: 'instinct' },
  { name: 'IntraVet', key: 'intravet' },
  { name: 'ProVet', key: 'provet' },
  { name: 'Shepherd', key: 'shepherd' },
  { name: 'Signature', key: 'signature' },
  { name: 'Stringsoft', key: 'stringsoft' },
  { name: 'Triple Crown', key: 'triple_crown' },
  { name: 'V-Tech Platinum', key: 'v_tech_platinum' },
  { name: 'VetBadger', key: 'vetbadger' },
  { name: 'VetFM', key: 'vetfm' },
  { name: 'VetPort', key: 'vetport' },
  { name: 'Vetspire', key: 'vetspire' },
  { name: 'VIA', key: 'via' },
];
